import React from 'react';
import { IDataBox } from '../DataBox.types';
import { Label } from '../DataBox.styles';

export default function DataBoxLabel({ children, testId = 'data-box-item' }: IDataBox) {
  return <Label data-testid={testId}>{children}</Label>;
}
